import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import accounts from "../../../api/accounts";
import verification from "../../../api/verification";
import CustomerInfoCom from "../CustomerInfoCom";
import LoadingOverlay from "../../Components/LoadingOverlay";

import {
  approveVerificationRequest,
  rejectVerificationRequest,
} from "../../../util/verificationRequestHelper";
import { handleError } from "@/util/errorHandler";
/*
This Component will be use for both Mobile Customer KYC infor, and Desktop User Customer Info
*/
class MobileCustomerInfo extends Component {
  state = {
    data: {},
    verificationRequest: null,
    isVerificationRequestLoading: true,
    isLoading: true,
  };

  loadUserInfo = async id => {
    try {
      const data = await accounts.getAccountDetails(id);

      this.setState({ data });
    } catch (err) {
      handleError(err);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  loadVerificationRequest = async accountId => {
    try {
      if (this.props.type !== "auditor") {
        return await verification
          .getActiveVerificationRequest(accountId)
          .then(({ verificationRequest }) =>
            this.setState({ verificationRequest }),
          );
      }
    } catch (error) {
      handleError(error);
    } finally {
      this.setState({ isVerificationRequestLoading: false });
    }
  };

  componentDidMount() {
    this.updateUserData();
  }

  updateUserData() {
    const id = this.props.match.params.id;
    this.loadUserInfo(id);
    this.loadVerificationRequest(id);
  }

  onBack = props => {
    this.props.history.goBack();
  };

  render() {
    const {
      isLoading,
      isVerificationRequestLoading,
      verificationRequest,
      data,
    } = this.state;

    return (
      <div>
        <Row>
          <Col style={{ display: "relative" }}>
            <LoadingOverlay
              loading={isLoading || isVerificationRequestLoading}
            />

            <CustomerInfoCom
              data={{
                ...data,
                requestStatus: this.state.data.kycStatus,
              }}
              type={this.props.type}
              approvable={
                this.props.type === "auditor"
                  ? false
                  : Boolean(verificationRequest)
              }
              onApprove={selectedUserLimit =>
                approveVerificationRequest(
                  {
                    verificationId: verificationRequest.id,
                    limitId: selectedUserLimit,
                  },
                  () => this.updateUserData(),
                )
              }
              onReject={() =>
                rejectVerificationRequest(verificationRequest.id, () =>
                  this.updateUserData(),
                )
              }
              updateAccount={() => this.updateUserData()}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default MobileCustomerInfo;
